<!--
Author: TangChen
Date: 2018-09-06
Desc: 设置页面底部，为公共组件
 -->
<template>
    <div class="comp-fund-list comp">
        <el-row v-if="fundInfo.length <= 0" class="no-funds">
            <el-col :span="12" :offset="8">
                <span class="no-funds-img" />
                <div class="no-funds-box">
                    <p>{{ noFundMsg }}</p>
                </div>
            </el-col>
        </el-row>
        <el-table
            v-if="fundInfo.length > 0"
            :data="fundAll"
            style="width: 100%"
            :show-header="false"
        >
            <el-table-column label="基金信息" :width="url !== 'glist' ? '960' : '1040'">
                <template slot-scope="scope">
                    <el-row class="fund-list">
                        <el-col :span="24" class="fund-tit">
                            <span v-for="fund in recommendFund" :key="fund.subitem">
                                <span
                                    v-if="
                                        scope.row.tagids &&
                                        scope.row.tagids.indexOf(fund.subitem) > -1
                                    "
                                    class="type-index"
                                    :style="{ 'background-color': fund.tagcolor }"
                                >
                                    {{ fund.subitemname }}
                                </span>
                            </span>
                            <span style="cursor: pointer" v-on:click="gotoDetail(scope.row)">
                                {{ scope.row.fundname + "(" + scope.row.fundcode + ")" }}
                                <i
                                    class="risk"
                                    aria-hidden="true"
                                    :class="$util.riskCla(scope.row.risklevel)"
                                >
                                    {{ $cache.getDict("110143", scope.row.risklevel) + "风险" }}
                                </i>
                            </span>
                        </el-col>
                        <el-col v-if="scope.row.reason" :span="24" class="spe-intro">
                            <p>{{ scope.row.reason }}</p>
                        </el-col>
                        <!--成立以来 今年以来暂时没数据但返回的是0 展示‘--’-->
                        <el-col :span="5">
                            <span :class="$util.colorClass(formatterRate(scope.row.allud))">
                                {{ formatterRate(scope.row.allud) }}
                            </span>
                            <p>成立以来</p>
                        </el-col>
                        <el-col :span="5">
                            <span :class="formatterRate(scope.row.thisyear1ud)">
                                {{ formatterRate(scope.row.thisyear1ud) }}
                            </span>
                            <p>今年以来</p>
                        </el-col>
                        <el-col v-if="scope.row.fundtype !== '2'" :span="5">
                            <span>{{ $util.fmtNum(scope.row.nav, 4) }}</span>
                            <p>{{ "单位净值(" + $util.fmtDate(scope.row.navdate) + ")" }}</p>
                        </el-col>
                        <el-col v-else :span="5">
                            <span>{{ formatterRate(scope.row.growthrate) }}</span>
                            <p>七日年化</p>
                        </el-col>
                        <el-col v-if="scope.row.fundtype !== '2'" :span="5">
                            <span>{{ $util.fmtNum(scope.row.totalnav, 4) }}</span>
                            <p>累计净值(元)</p>
                        </el-col>
                        <el-col v-else :span="5">
                            <span>{{ $util.fmtNum(scope.row.fundincomeunit, 4) }}</span>
                            <p>万份收益(元)</p>
                        </el-col>
                        <el-col :span="4">
                            <span
                                :class="
                                    $util.colorClass(
                                        fundGrowQry
                                            ? formatterRate(scope.row[fundGrowQry])
                                            : formatterRate(scope.row.dayfloatprofit)
                                    )
                                "
                            >
                                {{
                                    fundGrowQry
                                        ? formatterRate(scope.row[fundGrowQry])
                                        : formatterRate(scope.row.dayfloatprofit)
                                }}
                            </span>
                            <p>{{ fundGrowQry ? growArea[fundGrowQry] : "日涨跌幅" }}</p>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column v-if="$util.getConfig().onlyPrivateFund" label="购买" width="100">
                <template slot-scope="scope">
                    <el-tooltip
                        v-if="scope.row.isBuy || scope.row.issale == '0'"
                        class="item"
                        effect="info"
                        :content="
                            scope.row.issale == '0' ? '该产品非在售' : scope.row.isBuy + ',不能购买'
                        "
                        placement="left"
                    >
                        <el-button v-show="url !== 'glist'" type="lock" size="small">
                            购买
                        </el-button>
                    </el-tooltip>
                    <el-button
                        v-else
                        v-show="url !== 'glist'"
                        type="orange"
                        size="small"
                        v-on:click="showBuyModal(scope.row.fundcode)"
                    >
                        {{ scope.row.isBuy === "" ? "购买" : "认购" }}
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column
                v-if="$util.getConfig().hideFunc && !$util.getConfig().onlyPrivateFund"
                label="基金操作"
                prop="fundcode"
                align="center"
                :min-width="url !== 'glist' ? '198px' : '108px'"
            >
                <template slot-scope="scope">
                    <el-tooltip
                        v-if="scope.row.isBuy"
                        class="item"
                        effect="info"
                        :content="scope.row.isBuy + ',不能购买'"
                        placement="left"
                    >
                        <el-button v-show="url !== 'glist'" type="lock" size="small">
                            购买
                        </el-button>
                    </el-tooltip>
                    <el-button
                        v-else
                        v-show="url !== 'glist'"
                        type="orange"
                        size="small"
                        v-on:click="callbackFn('20,22', scope.row.fundcode)"
                    >
                        {{ scope.row.status === "1" ? "认购" : "购买" }}
                    </el-button>
                    <el-tooltip
                        v-if="scope.row.isCurrency"
                        class="item"
                        effect="info"
                        :content="scope.row.isCurrency + ',不能定投'"
                        placement="left"
                    >
                        <el-button
                            type="lock"
                            size="small"
                            :class="{ 'alone-btn': url === 'glist' }"
                        >
                            定投
                        </el-button>
                    </el-tooltip>
                    <el-button
                        v-else
                        type="yellow"
                        size="small"
                        :class="{ 'alone-btn': url === 'glist' }"
                        v-on:click="callbackFn('59', scope.row.fundcode)"
                    >
                        定投
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > conf.PAGE_SIZE" class="page-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                background
                layout="prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="dataReset"
            />
        </el-row>
        <qr-code
            :fundcode="selectFundCode"
            :dialog-visible="buyDialogVisible"
            v-on:dialog-close="buyDialogVisible = false"
        ></qr-code>
    </div>
</template>
<script>
import qrCode from "@/components/fund/qrCodeGuide";

export default {
    name: "AssetsList",
    components: {
        qrCode
    },
    props: {
        fundInfo: {
            type: Array,
            default: () => {
                return [];
            },
            required: true
        },
        allPage: {
            type: String,
            default: ""
        },
        noFundMsg: {
            type: String,
            default: "基金公司没有添加基金产品，请联系基金公司添加！ "
        },
        fundGrowQry: {
            type: String,
            default: ""
        },
        isPublic: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            buyDialogVisible: false, // 是否显示购买弹窗
            selectFundCode: "", // 所选基金代码
            userInfo: {},
            fundAll: [],
            curPage: 1,
            url: "", // 当前页面路由命名
            recommendFund: [],
            growArea: {
                dayfloatprofit: "日涨跌幅",
                month1ud: "近一月涨跌幅",
                month3ud: "近三月涨跌幅",
                month6ud: "近六月涨跌幅",
                year1ud: "近一年涨跌幅",
                year3ud: "近三年涨跌幅",
                year5ud: "近五年涨跌幅",
                allud: "成立以来"
            }
        };
    },
    watch: {
        fundInfo() {
            this.getNewFund();
        },
        allPage() {
            this.curPage = 1;
        }
    },
    mounted() {
        this.userInfo = this.$cache.getUser();
        this.url = this.$route.name;
        this.conf = this.$util.getConfig().const;

        this.getFundLabel();
    },
    methods: {
        gotoDetail(val) {
            // this.$util.toCompPage("/fund",{secondtype: val.fundcode,etfflag: val.etfflag});
        },
        showBuyModal(fundcode) {
            this.selectFundCode = fundcode;
            this.buyDialogVisible = true;
        },
        callbackFn(way, fundcode) {
            let moduleId = "";
            const fund = this.fundAll.filter((item) => {
                return item.fundcode === fundcode;
            });
            if (way == "59") {
                moduleId = way;
            } else {
                if (fund[0].isBuy === "") {
                    moduleId = "22";
                } else {
                    moduleId = "20";
                }
            }
            // 申购 22 认购 20
            this.$util.checkGtOcrModule(moduleId, "0", (res) => {
                this.$emit("fund-continue", way, fund[0]);
                /* if (res.checkFlag && this.userInfo.needOcrUpload === "1") {
                    this.$msgbox({
                        title: "证件未上传",
                        message: this.$createElement("div", null, [
                            this.$createElement(
                                "span",
                                null,
                                "您的证件资料还未上传，请先上传有效证件。"
                            )
                        ]),
                        showCancelButton: false,
                        confirmButtonText: "立即上传",
                        type: "warning",
                        customClass: "info-check",
                        beforeClose: (action, instance, done) => {
                            if (action === "confirm") {
                                this.$router.push({
                                    name: "ocrinfoupd",
                                    query: { certificatetype: "1" }
                                });
                                done();
                            } else {
                                done();
                            }
                        }
                    });
                }else {
                    this.$emit("fund-continue", way, fund[0]);
                } */
            });
        },
        getNewFund() {
            let _arr = [];
            this.fundInfo.forEach((fund, index) => {
                const _x = Object.assign({}, fund);
                _x.index = index + 1;
                _x.isBuy = this.$util.checkBuy(_x.status);
                _x.isCurrency = this.$util.checkGeneral(_x);
                _arr.push(_x);
            });
            this.fundAll = _arr;
        },
        dataReset(val) {
            this.$emit("new-fund", val);
        },
        // 获取产品标签
        getFundLabel() {
            this.recommendFund = this.$cache.getDict("90197", undefined);
            this.getNewFund();
            // this.$util.request("trade/fund/tag&").then(res => {
            //     this.recommendFund = res.data;
            //     this.getNewFund();
            // });
        },
        // 格式化涨跌幅数据 私募数据要乘以100
        formatterRate(rate) {
            if (!rate) {
                return "--";
            }
            if (!this.isPublic) {
                rate = rate * 100;
            }
            return this.$util.fmtNum(rate) + "%";
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-fund-list {
    .el-button--small {
        min-width: 80px;
        font-size: $f16;
        padding: 7px 15px;
    }
}
</style>
